export default __webpack_public_path__ + "static/media/Snd_2.5a4379b4.mp3";